import React from "react";

export default function formatChange(num) {
  const value = Number(num ?? 0);
  let color = "white";
  if (value > 0) color = "#7ED957";
  if (value < 0) color = "#FF4D4D";
  return <span style={{ color }}>{value.toFixed(2)}%</span>;
}
